
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code2 } from "@/views/resources/documentation/element-ui/basic/button/code";

export default defineComponent({
  name: "disabled-button",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code2
    };
  }
});
